export function calculateFirstEntryNotionalByMode(source: any, scalingMode: string) {
  const settings = source.settings || {};
  const leverage = Number(source.leverage ?? settings.leverage ?? 1);
  const entryType = source.entry_type ?? settings.entry_type ?? 'fixed';

  let entryCost = 0;

  if (scalingMode === 'custom') {
    // 커스텀 모드: 사다리의 첫 번째 항목 비용을 사용
    const targets = source.custom_targets || settings.custom_targets;
    if (Array.isArray(targets) && targets.length > 0) {
      const firstTarget = targets[0];
      entryCost = Number(firstTarget.cost || firstTarget.target_cost || 0);
      // 만약 cost가 없으면 price * qty로 역산
      if (entryCost === 0) {
        const p = Number(firstTarget.target_price || firstTarget.price || 0);
        const q = Number(firstTarget.target_qty || firstTarget.qty || 0);
        entryCost = (p * q) / leverage;
      }
    }
  } else {
    // 자동 모드: entry_amount 또는 base_qty 사용
    let amountVal = Number(source.entry_amount ?? settings.entry_amount ?? source.base_qty ?? 0);
    // [Fix] 만약 설정된 값이 전혀 없다면 전략 엔진의 기본값(10)을 가정
    if (amountVal === 0) amountVal = 10;

    if (entryType === 'fixed') {
      entryCost = amountVal;
    } else {
      // 퍼센트 (%) 모드: 기준이 되는 자산을 결정
      const principal = Number(source.principal_amount ?? settings.principal_amount ?? 0);
      const balance = Number(source.balance ?? settings.balance ?? 0);
      const equity = Number(source.total_equity ?? settings.total_equity ?? 0);

      // [Fix] 모든 기준 자산이 0일 경우, 전략 엔진(Strategy)의 시뮬레이션 기본 기반 자산인 1000을 fallback으로 사용
      // 이렇게 해야 신규 생성 중인 봇이나 설정 전 단계에서도 최소 규모 경고가 유의미하게 표시됨
      let basis = principal > 0 ? principal : (balance > 0 ? balance : equity);
      if (basis <= 0) basis = 1000;

      entryCost = basis * (amountVal / 100);
    }
  }

  // 최종 결과는 Notional (수령액 규모 = 증거금 * 레버리지)
  return entryCost * leverage;
}

// 하위 호환성을 위해 기존 함수명 유지하되 내부 로직 교체
export function calculateFirstEntryNotional(source: any) {
  const settings = source.settings || {};
  // source.scaling_mode가 우선, 없으면 settings.scaling_mode, 그 다음 custom_targets 존재 여부로 판별
  const scalingMode = source.scaling_mode || settings.scaling_mode ||
    (((source.custom_targets && source.custom_targets.length > 0) || (settings.custom_targets && settings.custom_targets.length > 0)) ? 'custom' : 'auto');
  return calculateFirstEntryNotionalByMode(source, scalingMode);
}

export function fmtDate(iso: string) {
  if (!iso) return '—';
  const d = new Date(iso);
  const kst = new Date(d.getTime() + 9 * 3600000);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${kst.getUTCFullYear()}-${pad(kst.getUTCMonth() + 1)}-${pad(kst.getUTCDate())} ${pad(kst.getUTCHours())}:${pad(kst.getUTCMinutes())}:${pad(kst.getUTCSeconds())}`;
}

export function getPricePrecision(symbol: string) {
  const s = symbol?.toUpperCase() || '';
  if (s.includes('XRP') || s.includes('DOGE') || s.includes('ENA') || s.includes('PEPE') ||
    s.includes('SHIB') || s.includes('ADA') || s.includes('TRX') || s.includes('XLM')) {
    return 4;
  }
  return 2;
}

export const fmtPriceForSymbol = (n: number | string, symbol: string) => {
  const val = typeof n === 'string' ? parseFloat(n) : n;
  if (!val || val <= 0) return '—';
  const d = getPricePrecision(symbol);
  return val.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
};

export const getExchangeBadgeStyle = (exchange?: string) => {
  const ex = (exchange || 'binance').toLowerCase();
  switch (ex) {
    case 'binance': return 'bg-amber-500/10 text-amber-600 dark:text-amber-500 border border-amber-500/20';
    case 'bitget': return 'bg-cyan-500/10 text-cyan-600 dark:text-cyan-500 border border-cyan-500/20';
    case 'okx': return 'bg-slate-500/10 text-slate-600 dark:text-slate-400 border border-slate-500/20';
    case 'bybit': return 'bg-orange-500/10 text-orange-600 dark:text-orange-500 border border-orange-500/20';
    default: return 'bg-muted/50 text-muted-foreground border-none';
  }
};

